import { FC, useState } from "react";
import {
  DialogContent,
  DialogActions,
  Typography,
  Button,
  FormLabel,
  Box,
  IconButton,
} from "@material-ui/core";
import CsvIcon from "icon/csvIcon.png";
import ClearIcon from "@material-ui/icons/Clear";
import { ellipsis } from "utils/formats";
import { closeModal } from "actions/modalActions";
import { useDialogStyles } from "../styles";
import { useDispatch } from "react-redux";
import api from "api";
import { customToast } from "hooks/toast";
import { DialogButton } from "components/buttons/DialogButton";

interface UploadExelWhcDialogProps {}

export const UploadExelWhcDialog: FC<UploadExelWhcDialogProps> = () => {
  const classes = useDialogStyles();
  const dispatch = useDispatch();
  const [file, setFile] = useState<File | null>(null);

  const onClose = () => dispatch(closeModal());

  const handleClose = () => {
    setFile(null);
    onClose();
  };

  const handleSubmit = () => {
    if (file != null) {
      handleClose();
      const request: FormData = new FormData();
      request.append("xlsx_file", file);
      api
        .uploadXlsxWhc(request)
        .then((res) => {
          if (res.data) {
            customToast("success", "Xlsx file was uploaded!");
          }
        })
        .catch(() => customToast("error", "Xlsx file was not uploaded! Please try again."));
    }
  };

  const onClear = () => {
    setFile(null);
  };

  return (
    <>
      <DialogContent
        data-testid="uploadExelWhcDialog"
        className={classes.modelContentDefaults}
        style={{ justifyContent: "space-between" }}
      >
        <FormLabel htmlFor="btn-upload">
          <input
            id="btn-upload"
            name="btn-upload"
            style={{ display: "none" }}
            type="file"
            accept=".xlsx"
            onChange={(e) => {
              if (e?.target?.files?.[0]) {
                setFile(e?.target?.files?.[0]);
              }
            }}
          />
          <Button
            fullWidth
            className="btn-choose"
            component="span"
            color="primary"
            variant="contained"
          >
            Choose File
          </Button>
        </FormLabel>
        {file ? <FileCard file={file} onClear={onClear} /> : null}
      </DialogContent>
      <DialogActions data-testid="uploadExelWhcDialogActions" className={classes.dialogActions}>
        <DialogButton
          testId={"cancelUploadExelWhcDialogButton"}
          buttonText={"Cancel"}
          onClick={onClose}
          variant="contained"
          color="secondary"
        />
        <DialogButton
          testId={"uploadUploadExelWhcDialogButton"}
          buttonText={"Upload"}
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={file === null}
        />
      </DialogActions>
    </>
  );
};

const FileCard = ({ file, onClear }: { file: File; onClear: () => void }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", my: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <img src={CsvIcon} height="40" alt="logo" />
        <Box sx={{ mx: 2 }}>
          <Typography>
            {ellipsis(file.name)} ({Number(file.size / 1000000).toFixed(2)} MB)
          </Typography>
        </Box>
      </Box>
      <IconButton onClick={onClear}>
        <ClearIcon />
      </IconButton>
    </Box>
  );
};
